import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  title: {
    color: theme.palette.primary.dark,
    fontFamily: 'AvenirNextLTW01-Medium',
  },
  image: {
    maxWidth: '100%',
    height: 'auto',
  },
}))

export default useStyles
